export default __webpack_public_path__ + "static/media/double-caret-horizontal.8cc3b945.svg";